import { render, staticRenderFns } from "./CompanySettingsOverview.vue?vue&type=template&id=73865f34"
import script from "./CompanySettingsOverview.vue?vue&type=script&lang=ts"
export * from "./CompanySettingsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports